import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const CustomerView = lazy(() => import("../components/Customer/ParentCustomerView.jsx"));
const CustomerSubDetails = lazy(() => import("../components/Customer/Admin/View/CustomerDetails/CustomerDetails.jsx"));

export default [
  { path: ROUTES.CUSTOMERS.VIEW, element: <LazyRoute><CustomerView /></LazyRoute> },
  { path: ROUTES.CUSTOMERS.DETAILS, element: <LazyRoute><CustomerSubDetails /></LazyRoute> },
];
